import { render } from "./Index.vue?vue&type=template&id=4150c9c7"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4150c9c7&lang=scss"
script.render = render

export default script